import React from 'react';
import { TextField } from 'mui-rff';
import { TextFieldTypes } from '../../../../../Interfaces/Forms';

interface Props {
  name: string;
  label: string;
  fieldType: TextFieldTypes;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
}

export const GeneralInputFormControl: React.FC<Props> = ({
  name,
  label,
  fieldType,
  required = false,
  fullWidth = false,
  disabled = false,
  placeholder = undefined,
}) => (
  <TextField
    label={label}
    name={name}
    type={fieldType}
    required={required}
    size="small"
    fullWidth={fullWidth}
    disabled={disabled}
    placeholder={placeholder}
  />
);
